export const DEVELOPERS = [
    {
        id: 1,
        fullName: 'D_12 team',
    },
    {
        id: 2,
        fullName: 'Яковлева Анна Сергеевна',
        group: 'С224',
    },
    {
        id: 3,
        fullName: 'Ярополов Кирилл Сергеевич',
        group: 'С224',
    },
]
